<template>
    <div class="cf-toolbar">
        <p class="cf-toolbar-desc">{{ $t('admin.companies.subtitle') }}</p>
        <router-link to="/admin/companies/create" class="cf-btn-create">
            <i class="fal fa-plus"></i>
            <span>{{ $t('companies.create_company') }}</span>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'CompaniesFilters'
}
</script>

<style scoped>
.cf-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--v2-space-3);
    padding: var(--v2-space-4) var(--v2-space-5);
    border-bottom: 1px solid var(--v2-border);
}

.cf-toolbar-desc {
    flex: 1;
    margin: 0;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    min-width: 0;
}

.cf-btn-create {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    padding: 0 14px;
    border-radius: var(--v2-radius-md);
    background: var(--v2-primary);
    color: #fff !important;
    font-size: var(--v2-text-xs-size);
    font-weight: var(--v2-font-weight-semibold);
    text-decoration: none !important;
    white-space: nowrap;
    transition: background var(--v2-transition-fast), box-shadow var(--v2-transition-fast);
    flex-shrink: 0;
}

.cf-btn-create i {
    color: #fff !important;
    font-size: 0.75rem;
}

.cf-btn-create:hover {
    background: var(--v2-primary-hover, #0e7490);
    box-shadow: var(--v2-shadow-sm);
}

@media (max-width: 900px) {
    .cf-toolbar {
        flex-direction: column;
        align-items: stretch;
        padding: var(--v2-space-3) var(--v2-space-4);
    }

    .cf-btn-create {
        justify-content: center;
    }
}
</style>
